export const GET_MY_POINTS_SUCCESS = 'GET_MY_POINTS_SUCCESS';
export const GET_POINTS_GOODS_LIST_SUCCESS = 'GET_POINTS_GOODS_LIST_SUCCESS';
export const GET_POINTS_YZ_QR_CODE_SUCCESS = 'GET_POINTS_YZ_QR_CODE_SUCCESS';
export const GET_POINTS_YZ_STATUS_SUCCESS = 'GET_POINTS_YZ_STATUS_SUCCESS';
export const SET_PAY_STEP = 'SET_PAY_STEP';
export const SET_IS_PAYPAL_SUBMITTING = 'SET_IS_PAYPAL_SUBMITTING';
export const SET_QUERY_PAYPAL_INFO = 'SET_QUERY_PAYPAL_INFO';
export const MAKE_POINTS_PAYPAL_URL_SUCCESS = 'MAKE_POINTS_PAYPAL_URL_SUCCESS';
export const GET_POINTS_PAYPAL_INFO_SUCCESS = 'GET_POINTS_PAYPAL_INFO_SUCCESS';
export const GET_POINTS_PAYPAL_RESULT_SUCCESS = 'GET_POINTS_PAYPAL_RESULT_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_IS_REQUEST_LONG_STATUS = 'SET_IS_REQUEST_LONG_STATUS';
export const LOADING_MESSAGE = '请稍等...';
